import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  action: 'hash',
  algorithm: 'sha256',
  encryptionAlgorithm: 'aes-256-cbc',
  encoding: 'hex',
  keyLength: 32,
  // JWT defaults
  jwtAlgorithm: 'RS256',
  jwtValidateLifetime: true,
  jwtValidateIssuer: false,
  jwtValidateAudience: false,
};

export default defaults;
